import axiosClient from "../axiosClient";
import { LOGIN_URL,ENABLE_URL,Verify_URL,TWOFACTORSTATUS_URL ,DEACTIVATE_URL,REFRESH_URL, RESETPASSWORDLINK_URL, RESETPASSWORD_URL, VALIDATERESETOKEN_URL, VerifyCONCURRENT_URL, TERMINATE_URL, GETBRANCH} from "../endpoints";


export const authService = {
  login: async (email: string, password: string) => {
    try {
      const response = await axiosClient.post( LOGIN_URL, { email, password });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Login failed');
    }
  },  

  EnableTwoFactor: async (Id: string) => {
    try {
      const response = await axiosClient.post(ENABLE_URL, { Id });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Failed to complete two-factor authentication');
    }
  },
  
  VerifyOtp: async (Id: string,otpCode:string )=> {
    try {
      const response = await axiosClient.post(Verify_URL, { Id,otpCode });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Failed to complete two-factor authentication');
    }
  },
  TerminateOtherSessions: async (Id: string )=> {
    try {
      const response = await axiosClient.post(TERMINATE_URL, { Id, });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Failed to complete two-factor authentication');
    }
  },
  VerifyOtpConcurrent: async (Id: string,otpCode:string,forceLogin:boolean) => {
    try {
      const response = await axiosClient.post(VerifyCONCURRENT_URL, { Id,otpCode,forceLogin });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Failed to complete two-factor authentication');
    }
  },

  UpdateTwoFactorStatus: async (userId: string, isEnabled: boolean) => {

    try {
      const response = await axiosClient.post(TWOFACTORSTATUS_URL, { userId,isEnabled });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Failed to complete two-factor authentication');
    }
  },
  DeActivateTwoFactorStatus: async (userId: string) => {

    try {
      const response = await axiosClient.post(DEACTIVATE_URL, { userId});
      return response.data; // Returns response data
    } catch (error) {
      throw new Error('Failed to complete two-factor authentication');
    }
  },
  RefreshTokenService : async (refreshToken: string) => {
    try {
      const response = await axiosClient.post(REFRESH_URL, { refreshToken });
      return response.data.data; // Return the token data
    } catch (error: any) {
      throw new Error(error.message || 'Failed to refresh token');
    }
  },

  ResetpasswordlinkService : async (Email: string) => {
    try {
      const response = await axiosClient.post(RESETPASSWORDLINK_URL, { Email });
      return response; 
    } catch (error: any) {
      throw new Error(error.message || 'Failed to refresh token');
    }
  },

  ValidateResetToken: async (Email: string, Token: string, resetPasswordExpirationTime: string) => {
    try {
        const response = await axiosClient.post(VALIDATERESETOKEN_URL, { Email, Token, resetPasswordExpirationTime });
        return response.data; // Ensure only relevant data is returned
    } catch (error: any) {
      const errorMessage = error.response?.data?.errors?.[0]?.description || "Failed to validate reset token";
        return { success: false, message: errorMessage };
    }
},

  Resetpassword: async (Email: string, Token: string, NewPassword: string, ) => {
    try {
      const response = await axiosClient.post(RESETPASSWORD_URL, { Email, Token, NewPassword});
      return response;
    } catch (error: any) {
      // Check for response error, this ensures we capture any backend response errors
      throw new Error(error.response?.data?.message || "Failed to validate reset token");
    }
  },
  branchById: async (requestData: { branchIds: string[] }) => {
    try {
      const response = await axiosClient.post(GETBRANCH, requestData);
      console.log("API Response:", response.data); // Debug log
      return response.data;
    } catch (error) {
      console.error("Failed to fetch Feature details:", error);
      throw new Error("Failed to fetch Feature details");
    }
  },
  logout: () => {
    // Clear any stored session or token
    sessionStorage.removeItem('authData');
    localStorage.removeItem('authToken');
  },
};
